<!--选择excle文件并上传页面-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;display: flex;justify-content: flex-end;">
          <el-tooltip class="item" effect="dark" content="添加一条数据" placement="bottom">
            <el-button type="primary" @click="addRow()">添加</el-button>
          </el-tooltip>
        </div>
        <div style="margin-left: 10px;">
          <div>
            <el-divider><span style="font-size: 20px;">{{form_name}}</span></el-divider>
          </div>
          <!--表格内容-->
          <div>
            <el-table border :data="dataList" style="width: 100%" empty-text="数据"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}">
              <el-table-column header-align="center" resizable align="center" :key="header" :label="header.label"
                :prop="header.prop" v-for="(header) in headers">
                <template slot="header" slot-scope="scope">
                  <div>
                    <div style="font-size: 18px;" v-if="header.optional=='1'">{{header.label}}</div>
                    <div style="font-size: 18px;color:red;" v-else>{{header.label}}</div>
                    <div style="font-size: 12px;">【{{header.type}} {{getOptionlabel(header)}}】</div>
                  </div>
                </template>
                <template slot-scope="scope">

                  <div v-if="header.type=='图片' || header.type=='签名'">
                    <el-image style="width: 100px; height: 100px" :src="scope.row[header.prop]"></el-image>
                  </div>
                  <div v-else-if="header.type=='视频'">
                    <video v-bind:src="scope.row[header.prop]" class="avatar video-avatar" controls="controls">
                      您的浏览器不支持视频播放
                    </video>
                  </div>
                  <div v-else>
                    <p>{{scope.row[header.prop]}}</p>
                  </div>
                </template>

              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <div class="actionStyle">
                    <el-button @click="deleteRecord(scope.row)" type="text" size="small">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        form_id: '',
        form_name: '',
        dataList: [],
        headers: []
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name
      // this.loadCourses()
      this.loadData()
    },
    methods: {
      loadData() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_load_form_all_data.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id
            }
          }).then(function(response) {
            that.dataList = response.data.dataList
            that.headers = response.data.headers

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      deleteRecord(row) {
        let that = this

        var data_row_id = row.data_row_id

        this.$confirm('此操作将永久删除该行, 要删除吗?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteRow(data_row_id)
        }).catch(() => {
          // that.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })

        console.log(data_row_id)
      },
      deleteRow(data_row_id) {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_delete_row_by_data_row_id.jsp'
        this.axios.get(requestUrl, {
            params: {
              data_row_id: data_row_id
            }
          }).then(function(response) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })

            load.close()

            that.loadData()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      addRow() {
        let that = this
        this.$router.push({
          name: 'add_record',
          params: {
            form_id: that.form_id,
            form_name: that.form_name
          }
        })
      },
      getOptionlabel(header) {
        if (header.optional == '1') {
          return '选填'
        } else {
          return '必填'
        }
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  }


  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/browse_all_data.vue